


















export default
    props:
        # The index of the selected option
        value:
            type: Number
        # The display text for the options
        options:
            type: Array
            required: false
            default: ->
                return ['Exclude', 'Neutral', 'Require'] 
